import { Component, OnInit } from '@angular/core';
import { Staff } from '../../../entity/Staff';
import { StaffService } from 'src/app/service/staff.service';
 


@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html'
})
export class StaffComponent implements OnInit {

  selectedStaff: Staff;
  staffs: Staff[]
  msgspr;
  loading;
  cols: any;
  isEdit:boolean;
  selectedProjets: string;
  selectedRoles: string[] = [];
  constructor(private staffService: StaffService) { }

  ngOnInit() {
    this.cols = [

      { field: 'nom', header: 'Nom' }
    ];
    this.findAllStaffs()
  }

  findAllStaffs() {
    this.staffService.getAllStaffs().subscribe(result => {
      this.staffs = result
    })
  }


  createStaff() {
    let staff: Staff = new Staff()
    staff.nom = "new User"
    this.staffService.addStaff(staff).subscribe(result => {
      this.findAllStaffs()
    })
  }

  archiverUser(){
    this.selectedStaff.archivee=true;
    this.selectedStaff.enabled=false;
    this.staffService.updateStaff(this.selectedStaff).subscribe(result => {
this.findAllStaffs()
    })   
    
}



  save() {
//console.log("staff "+JSON.stringify(this.selectedStaff));
 this.selectedStaff.roleUser=this.selectedRoles.join(', ')
    this.staffService.updateStaff(this.selectedStaff).subscribe(result => {

    })
  }

  removeStaff() {
    this.staffService.deleteStaff(this.selectedStaff).subscribe(result => {
      let resSTR = JSON.stringify(result);
      let resJSON = JSON.parse(resSTR);

      this.findAllStaffs()
    }, error =>
        (alert(error)))

  }
  selectStaff() {
    if (this.selectedStaff.projet)
      this.selectedProject = this.selectedStaff.projet.split(' ')
    else
      this.selectedProject = []


      this.selectedRoles =   this.selectedStaff.roleUser.split(', ')
  }


  selectedProject: String[];
  projets = [
    { label: 'HASSI', value: 'HASSI' },
    { label: 'NAPEC', value: 'NAPEC' },
    { label: 'DELEGATE', value: 'DELEGATE' },
    { label: 'SPONSOR', value: 'SPONSOR' },
    { label: 'AUTREs', value: 'AUTRE' }
  ];
  selectProjectPr() {


    this.selectedStaff.projet = this.selectedProject.join(' ');


  }
  public CkeditorConfig1 = {
    allowedContent: true,
    extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*);',
    CKEDITOR: [{ dtd: { $removeEmpty: { i: 0 } } }],
    height: 320,
    toolbarGroups: []
  }
  public CkeditorConfig = {
    allowedContent: true,
    extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*);',
    CKEDITOR: [{ dtd: { $removeEmpty: { i: 0 } } }],
    height: 320,
    toolbarGroups: [


      { name: 'forms', groups: ['forms'] },
      { name: 'styles', groups: ['styles'] },
      { name: 'colors', groups: ['colors'] },


      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },


    ],
    removeButtons: 'Save,NewPage,Print,Paste,PasteText,PasteFromWord,Scayt,Form,Radio,Checkbox,TextField,Textarea,Select,Button,ImageButton,HiddenField',
    removePlugins: 'htmldataprocessor',
    protectedSource: [/{{[\s\S]*?}}/g],
    //CKEDITOR.dtd:[{$removeEmpty:{i: false}}]
    // CKEDITOR.dtd:false
    //.dtd.$removeEmpty['i'] = false

  }
  public CKEDITOR = [];
}
